export function queryString() {
  let query_string = {};
  let query = window.location.search.substring(1);

  if (!query) return "";

  let lets = query.split("&");

  for (let i = 0; i < lets.length ; i++) {
    let pair = lets[i].split("=");

    // third party query params can feed in just the key,
    // this adds a default empty string to avoid breaking subsequent code.
    if (pair[1] === undefined) pair[1] = "";

    // If first entry with this name
    if (typeof query_string[pair[0]] === "undefined") {
      query_string[pair[0]] = pair[1].replace(/%20/g, "+");
    // If second entry with this name
    } else if (typeof query_string[pair[0]] === "string") {
      let arr = [ query_string[pair[0]], pair[1].replace(/%20/g, "+") ];
      query_string[pair[0]] = arr;
    // If third or later entry with this name
    } else {
      query_string[pair[0]].push(pair[1].replace(/%20/g, "+"));
    }

  }

  return query_string;

};